import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';
import {Stat} from '../../stat/Stat';

export class EventServerLoginHandler {
    public handle(): void {
        ClientEventEmitter.fireEvent(ClientEvents.SERVER_LOGIN);
        Stat.flushQueue();
    }
}
